import React, { useState, useEffect } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';



const ScrapBarChart = ({data}) => {
  const [selectedValue, setSelectedValue] = useState('Total');
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const updatedData = data.map(item => ({
      name: item.Nombre,
      value: item[selectedValue]
    }));
    setChartData(updatedData);
  }, [selectedValue]);

  const colors = ['#FF8042', '#00C49F'];

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  return (
    <div>
      <label className="form-label" htmlFor="filter">Seleccionar filtro: </label>
      <select className='form-select' onChange={handleSelectChange} value={selectedValue}>
        <option value="Total">Costo por producto</option>
        <option value="Cantidad">Cantidad de productos</option>
      </select>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData}  margin={{ top: 20, right: 20, left: 20, bottom: 70 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={0}
            angle={-25}
            textAnchor="end"
            style={{ fontSize: '10px' }}
          />
          <YAxis />
          <Tooltip />
          
          <Bar dataKey="value" fill="#8884d8">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
            <LabelList dataKey="value" position="top" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScrapBarChart;
